import { layoutOf } from "../../domain/layout";
import { dualAxle, singleAxle } from "../wheel-placements";
import {
  TRUCK_10,
  TRUCK_12,
  TRUCK_16,
  TRUCK_4,
  TRUCK_6,
  TRUCK_6_THREE_SINGLE,
  axleHalfTrack
} from "./dimensions";
const truckWheels = (d) => d.axles.flatMap((axle, i) => {
  const spec = {
    axle: i + 1,
    x: axle.x,
    radius: d.wheelRadius,
    width: d.tyreWidth,
    halfTrack: axleHalfTrack(d, axle)
  };
  switch (axle.fitment) {
    case "single":
      return singleAxle(spec);
    case "dual":
      return dualAxle({ ...spec, spacing: d.dualSpacing });
    default: {
      const _exhaustive = axle.fitment;
      return _exhaustive;
    }
  }
});
const TRUCK_6_LAYOUT = layoutOf(["single", "dual"]);
const TRUCK_6_WHEELS = truckWheels(TRUCK_6);
const TRUCK_10_LAYOUT = layoutOf(["single", "dual", "dual"]);
const TRUCK_10_WHEELS = truckWheels(TRUCK_10);
const TRUCK_12_LAYOUT = layoutOf(["single", "single", "dual", "dual"]);
const TRUCK_12_WHEELS = truckWheels(TRUCK_12);
const TRUCK_16_LAYOUT = layoutOf(["single", "single", "dual", "dual", "dual"]);
const TRUCK_16_WHEELS = truckWheels(TRUCK_16);
const TRUCK_6_THREE_SINGLE_LAYOUT = layoutOf(["single", "single", "single"]);
const TRUCK_6_THREE_SINGLE_WHEELS = truckWheels(TRUCK_6_THREE_SINGLE);
const TRUCK_4_LAYOUT = layoutOf(["single", "single"]);
const TRUCK_4_WHEELS = truckWheels(TRUCK_4);
export {
  TRUCK_10_LAYOUT,
  TRUCK_10_WHEELS,
  TRUCK_12_LAYOUT,
  TRUCK_12_WHEELS,
  TRUCK_16_LAYOUT,
  TRUCK_16_WHEELS,
  TRUCK_4_LAYOUT,
  TRUCK_4_WHEELS,
  TRUCK_6_LAYOUT,
  TRUCK_6_THREE_SINGLE_LAYOUT,
  TRUCK_6_THREE_SINGLE_WHEELS,
  TRUCK_6_WHEELS
};
